var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import * as React from 'react';
import { parseHostname } from '@ta-interaktiv/parse-hostname';

import { browserCheck } from '@ta-interaktiv/browsercheck';

/**
 * These are the properties that need to be passed in for correct tracking
 * to occur. Some of these properties can be found in the Paywall object in
 * the Newsnet `external_services` API, but not all of them and some of them
 * under different names.
 */


// region Configuration

/** Marker that is being used to mark a staging server */
var stagingServerMarker = /-igr/;

/** Version of the paywall scripts */
var paywallScriptsVersion = 'cre-1.0';

// endregion

/**
 * Enables paywall functionality on standalone projects.
 *
 * @example
 * import * as React from 'react'
 * import { Paywall as TamediaPaywall } from '@ta-interaktiv/react-paywall'
 * import { json } from 'd3-fetch'
 *
 * export class MyComponent extends React.Component {
 *   state = {
 *     paywallConfiguration: {},
 *     paywallStatus: 0
 *   }
 *
 *   render() {
 *     return (
 *       <div>
 *         {this.state.paywallStatus > 0
 *         && Object.entries(this.state.paywallConfiguration).length > 0
 *         && (<TamediaPaywall
 *             isEnabled={true}
 *             paywallConfiguration={this.state.paywallConfiguration}
 *             paywallStatus={this.state.paywallStatus}
 *           />)
 *         }
 *       </div>
 *     )
 *   }
 *
 *   componentDidMount() {
 *     // Get data from the Newsnet API, likely using d3-fetch
 *     // and set it using setState
 *
 *     json(`//api-endpoint`).then(data => {
 *       this.setState({
 *         paywallConfiguration: data.paywall,
 *         paywallStatus: data.configs.paywall_status
 *       })
 *     }
 *   }
 * }
 *
 *
 *
 *
 *
 * @param {Props} props
 * @param {boolean} props.isEnabled Whether to enable the paywall
 * functionality or not. Either set this manually or get the current paywall
 * state from the Newsnet API.
 * @param {string} [props.paywallContainerId=paywall_container] The ID of
 * the DIV into which paywall elements should be placed into.
 * @param {PaywallConfiguration} props.paywallConfiguration The paywall
 * configuration settings as provided by the Newsnet API. As this
 * information requires a request to the API, you have to wait to mount
 * this component until you have downloaded the required configuration from
 * the API. The component is not set up to handle a props change, as the
 * setup is done entirely in the constructor.
 * @param {PaywallStatus} [props.paywallStatus=0] The system-wide current status
 * of the paywall.
 */

var TamediaPaywall = function (_React$Component) {
  _inherits(TamediaPaywall, _React$Component);

  function TamediaPaywall(props) {
    _classCallCheck(this, TamediaPaywall);

    // Reset lists
    var _this = _possibleConstructorReturn(this, (TamediaPaywall.__proto__ || Object.getPrototypeOf(TamediaPaywall)).call(this, props));

    _this.state = {
      isMounted: false

      /** Track the loading state of each added script */
    };
    _this.paywallScripts = [];
    _this.scriptLoadingState = {};

    // Check whether we are within the app – this is passed in via a search
    // parameter. If this is present, we forego any paywall logic
    var isInApp = new URL(window.location.href).searchParams.has('appwebview');

    if (isInApp) {
      return _possibleConstructorReturn(_this);
    }

    var isOnStagingServer = stagingServerMarker.test(window.location.hostname);
    var subdomainSuffix = isOnStagingServer ? '-igr' : '';

    var hostname = parseHostname();

    // Paywall is enabled and needs at least the templateClient and tracking
    // scripts
    if (_this.props.paywallStatus > 0) {
      _this.paywallScripts.push(['templateClient', 'https://track' + subdomainSuffix + '.' + hostname.publicationDomain + '/' + paywallScriptsVersion + '/static/tracking/1.0/templateclient.js'], ['tracking', 'https://track' + subdomainSuffix + '.' + hostname.publicationDomain + '/' + paywallScriptsVersion + '/tracking/tracking.js']);

      _this.scriptLoadingState['templateClient'] = false;
      _this.scriptLoadingState['tracking'] = false;
    }

    // Paywall is enforcing the rules and needs the templates (well, not
    // really, but just in case we will download 1MB of code).
    if (_this.props.paywallStatus > 1) {
      _this.paywallScripts.push(['templateSets', 'https://track' + subdomainSuffix + '.' + hostname.publicationDomain + '/' + paywallScriptsVersion + '/cockpit/platform/tamedia/shop/' + hostname.publicationName + '/api/templatesets.js']);

      _this.scriptLoadingState['templateSets'] = false;
    }
    return _this;
  }

  /**
   * The list of intertwined scripts that are needed for the Tamedia Paywall
   * to run.
   * @type {{templateSets: string, templateClient: string, tracking: string}}
   */


  _createClass(TamediaPaywall, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      if (this.props.isEnabled) {
        this.paywallScripts.forEach(function (scriptDefinition) {
          var script = window.document.createElement('script');

          script.src = scriptDefinition[1];
          script.async = true;
          script.onload = function () {
            _this2.onLoadHandler(scriptDefinition[0]);
          };

          window.document.body.appendChild(script);
        });
      }
    }

    /**
     * This component is not rendering anything into the render tree.. It
     * internally
     * downloads additional scripts and executes them.
     * @return {null}
     */

  }, {
    key: 'render',
    value: function render() {
      return null;
    }

    // region Helper Methods
    /**
     * Execute the paywall setup scripts after all the scripts have been loaded.
     * @param scriptMarker - The name of the script to be marked as loaded
     */

  }, {
    key: 'onLoadHandler',
    value: function onLoadHandler(scriptMarker) {
      this.scriptLoadingState[scriptMarker] = true;

      // In case all those scripts have been loaded, even the ridiculously
      // overbloated ones, execute the necessary setup
      if (Object.values(this.scriptLoadingState).every(function (val) {
        return val;
      })) {
        this.setupPaywall();
      }
    }

    /**
     * Collects all actions that are necessary to set up the paywall
     */

  }, {
    key: 'setupPaywall',
    value: function setupPaywall() {
      // Start executing all these ridiculous scripts
      // cre_templateclient should at this point be defined thanks to the
      // embedded scripts
      window.cre_templateclient && window.cre_templateclient.setup({
        container_id: this.props.paywallContainerId
      });

      var origin = 'web';

      if (window.matchMedia('(max-width: 799px)').matches) {
        origin = 'mobile';
      }

      if (browserCheck.isNativeApp) {
        origin = 'app';
      }

      // Prepare paywall configuration data
      var config = {
        cms_id: this.props.paywallConfiguration.cms_id.toString(),
        content_id: window.location.pathname,
        doc_type: this.props.paywallConfiguration.doc_type,
        channel: this.props.paywallConfiguration.main_channel,
        sub_channel: this.props.paywallConfiguration.sub_channel,
        heading: window.document.title,
        service_id: parseHostname().publicationName,
        origin: origin
      };

      this.setTrackingData(config, 'page_view');
      this.setTrackingData(config, 'page_complete');
    }

    /**
     * Helper function that makes it easier to call the various set_ functions
     * of the cre_client, because just passing in a config object would be
     * waaaay too easy.
     * @param config - An object that contains the desired settings, with the
     * name of the wanted set_ function with 'set_' as keys and the values
     * that should be passed in.
     * @param action
     */

  }, {
    key: 'setTrackingData',
    value: function setTrackingData(config, action) {
      // die if no cre_client is available
      if (window.cre_client == null) {
        return;
      }

      // Execute action call
      window.cre_client['set_' + action]();

      // Add in all the configs
      Object.entries(config).forEach(function (keyValuePair) {
        // The object is called `cre_client`, even though the relevant code is
        // not to be found in templateclient.js, but in tracking.js. ¯\_(ツ)_/¯
        window.cre_client['set_' + keyValuePair[0]](keyValuePair[1]);
      });

      // Send the request
      window.cre_client.request();
    }

    // endregion

  }]);

  return TamediaPaywall;
}(React.Component);

TamediaPaywall.defaultProps = {
  paywallContainerId: 'paywall_container',
  paywallStatus: 0 };


export { TamediaPaywall };


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ta-interaktiv/react-paywall/es/paywall/index.js
// module id = 37
// module chunks = 0